import { useRef } from "react";
import { FiSliders } from "react-icons/fi";
import { StatsFilterModal } from '../../../components/coach/dashboard/StatsFilterModal';
import { SimpleDropdown } from '../../../components/common/SimpleDropdown';

export const FilterBar = ({
  positionValue,
  onPosChange,
  yearValue,
  onYearChange,
  onAddSubtractClick,
  showFilterModal,
  onCloseModal,
  onApplyFilters,
  uncommittedOnly,
  onUncommittedChange,
  statCategory = 'HITTING',
}) => {
  const defaultFilters = statCategory === 'PITCHING'
    ? ['ip', 'gs', 'era', 'whip', 'so', 'bb', 'k%', 'bb%']
    : ['ab', 'avg', 'obp', 'slg', 'runs', 'h', '2b', '3b', 'hr', 'k', 'bb'];
  const defaultTab = statCategory === 'PITCHING' ? 'pitching' : 'hitting';
  const buttonRef = useRef(null);

  // Generate year options - 2025 and 10 previous years in season format (2025-26)
  const currentYear = 2025;
  const yearOptions = [
    { label: 'Filter by Year', value: '' },
    { label: 'All', value: 'All' },
    ...Array.from({ length: 11 }, (_, i) => {
      const year = currentYear - i;
      return {
        label: `${year}-${(year + 1).toString().slice(-2)}`,
        value: year
      };
    })
  ];

  const positionOptions = [
    { label: 'All', value: '' },
    { label: 'Pitcher', value: 'P' },
    { label: 'C', value: 'C' },
    { label: '1B', value: '1B' },
    { label: '2B', value: '2B' },
    { label: '3B', value: '3B' },
    { label: 'SS', value: 'SS' },
    { label: 'LF', value: 'LF' },
    { label: 'CF', value: 'CF' },
    { label: 'RF', value: 'RF' },
    { label: 'INF', value: 'INF' },
    { label: 'OF', value: 'OF' },
  ];

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-end gap-2 sm:gap-3 w-full lg:w-auto relative">
      {/* Commitment Status Dropdown — moved to parent for ordering */}
      {/* <div className="w-full sm:w-auto" style={{ minWidth: '200px' }}>
        <SimpleDropdown
          value={uncommittedOnly}
          onChange={onUncommittedChange}
          options={[
            { label: 'All Players', value: '' },
            { label: 'Committed', value: 'committed' },
            { label: 'Uncommitted', value: 'uncommitted' },
          ]}
          placeholder="Commitment Status"
          variant="form"
        />
      </div> */}

      {/* Year Dropdown */}
      {/* <div className="w-full sm:w-auto" style={{ minWidth: '160px' }}>
        <SimpleDropdown
          value={yearValue}
          onChange={onYearChange}
          options={yearOptions}
          placeholder="Filter by Year"
          variant="form"
        />
      </div> */}

      {/* Position Dropdown */}
      {/* <div className="w-full sm:w-auto" style={{ minWidth: '180px' }}>
        <SimpleDropdown
          value={positionValue}
          onChange={onPosChange}
          options={positionOptions}
          placeholder="Filter by Position"
          variant="form"
        />
      </div> */}

      {/* Add/Subtract Filters button */}
      <button
        ref={buttonRef}
        onClick={onAddSubtractClick}
        className="inline-flex items-center justify-center gap-2 text-jp-ink font-medium h-11 px-4
                   rounded-lg border border-jp-line hover:bg-jp-section transition-colors
                   w-full sm:w-auto text-sm whitespace-nowrap"
        type="button"
      >
        <span>Add/Subtract Filters</span>
        <FiSliders className="text-jp-ink" size={18} />
      </button>

      {/* Stats Filter Modal */}
      <StatsFilterModal
        isOpen={showFilterModal}
        onClose={onCloseModal}
        onApply={onApplyFilters}
        buttonRef={buttonRef}
        defaultSelectedFilters={defaultFilters}
        defaultActiveTab={defaultTab}
      />
    </div>
  );
};
